import React, { FC } from 'react';
import QRCode from 'react-qr-code';

// Models
import { CgiProgressStatusType, CgiProvider } from '../../../models/CGI/CGI';

// i18n
import { useTranslation } from '../../../translations/useTranslation';

// Utils
import { getCgiProviderName } from '../../../utilities/cgi';

// Components
import { CircleLoader } from '../../common';

interface Props {
  progressStatus?: CgiProgressStatusType;
  provider: CgiProvider;
  qrCodeData?: string;
}

const CgiAnotherDevice: FC<Props> = ({
  qrCodeData,
  progressStatus,
  provider
}) => {
  const { t, m, keys } = useTranslation();
  const providerName = getCgiProviderName(provider)
  return (
    <div>
      <p>
        1.{' '}
        {m(
          keys.cgiAnotherDeviceStep1,
          '{provider}',
          providerName
        )}
        <br /> 2. {t(keys.cgiAnotherDeviceStep2)}
        <br /> 3. {t(keys.cgiAnotherDeviceStep3)}
      </p>
      {progressStatus === CgiProgressStatusType.USER_SIGN && (
        <CircleLoader size="sm" />
      )}
      {qrCodeData && (
        <div>
          <QRCode size={175} value={qrCodeData} />
        </div>
      )}
    </div>
  );
};

export default CgiAnotherDevice;
